import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { PortalModule } from '@duoduo-oba/ng-devui/portal';
import { TooltipDirective } from './tooltip.directive';
import { WindowRef } from '@duoduo-oba/ng-devui/window-ref';
import { DocumentRef } from '@duoduo-oba/ng-devui/window-ref';
import { OverlayContainerRef } from '@duoduo-oba/ng-devui/overlay-container';
import {PositioningModule} from '@duoduo-oba/ng-devui/position';

@NgModule({
  imports: [
    CommonModule,
    PortalModule,
    PositioningModule
  ],
  exports: [TooltipComponent, TooltipDirective],
  declarations: [TooltipComponent, TooltipDirective],
  providers: [
    WindowRef,
    DocumentRef,
    OverlayContainerRef,
  ],
  entryComponents: [TooltipComponent]
})
export class TooltipModule {
}
